import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './LoginPage.css';

const LoginPage = () => {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(email, password);
    } catch (err) {
      setError(err.message || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sq-login">
      <section className="sq-login__brand" aria-label="Soquimat ERP">
        <div className="sq-login__glow" aria-hidden="true" />
        <div className="sq-login__grid" aria-hidden="true" />

        <div className="sq-login__brand-top">
          <img
            className="sq-login__mark"
            src="/assets/soquimat-dark.png"
            alt=""
            aria-hidden="true"
          />
          <p className="sq-login__brand-word">Soquimat ERP</p>
        </div>

        <div className="sq-login__brand-main">
          <img
            className="sq-login__logo"
            src="/assets/soquimat-logo-white.png"
            alt="Soquimat — Soluciones Químicas y Materiales"
          />
          <h1 className="sq-login__headline">Sistema de Control Integrado</h1>
          <p className="sq-login__lede">
            Una sola plataforma para operar con claridad, orden y control.
          </p>
        </div>

        <p className="sq-login__brand-foot">SOQUIMAT SpA · Soluciones Químicas y Materiales</p>
      </section>

      <section className="sq-login__panel">
        <div className="sq-login__form-wrap">
          <p className="sq-login__form-kicker">Acceso</p>
          <h2 className="sq-login__form-title">Iniciar sesión</h2>
          <p className="sq-login__form-copy">
            Usa tu correo corporativo para entrar a la plataforma.
          </p>

          <form onSubmit={handleSubmit} className="sq-login__form">
            {error ? <div className="sq-login__error">{error}</div> : null}

            <div className="sq-login__field">
              <label className="sq-login__label" htmlFor="sq-login-email">
                Email
              </label>
              <input
                id="sq-login-email"
                className="sq-login__input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="usuario@soquimat.cl"
                required
                autoComplete="email"
                autoFocus
              />
            </div>

            <div className="sq-login__field">
              <label className="sq-login__label" htmlFor="sq-login-password">
                Contraseña
              </label>
              <input
                id="sq-login-password"
                className="sq-login__input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                autoComplete="current-password"
              />
            </div>

            <button
              type="submit"
              className="sq-login__submit"
              disabled={loading}
            >
              {loading ? 'Iniciando sesión…' : 'Entrar a Soquimat ERP'}
            </button>
          </form>

          <p className="sq-login__footnote">Acceso restringido a usuarios autorizados.</p>
        </div>
      </section>
    </div>
  );
};

export default LoginPage;
